import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import Collapse from '@mui/material/Collapse';
import Tooltip from '@mui/material/Tooltip';

import { KeyboardArrowDownIcon, KeyboardArrowUpIcon } from '../../../components/customStyles/images';
import { TextFieldWhite } from '../../../components/customStyles/form';

import { FormTitle, ProductTitle } from './generationFormStyle';


const ProductInfo = ({ generationForm }) => {
  const [showContent, setShowContent] = useState(false);

  const handleContentShow = () => {
    setShowContent(true);
  }

  const handleContentHide = () => {
    setShowContent(false);
  }

  return (
    <Box mb={5}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <FormTitle variant='h4' mr={1}>商品資訊</FormTitle>
        {showContent ? (
          <Tooltip title="隱藏商品資訊" placement="right-start">
            <IconButton onClick={handleContentHide}>
              <KeyboardArrowUpIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="展開商品資訊" placement="right-start">
            <IconButton onClick={handleContentShow}>
              <KeyboardArrowDownIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      <Collapse in={showContent}>
        <Box mt={2}>
          <ProductTitle variant='h5'>商品標題</ProductTitle>
          <TextFieldWhite
            name="product_title"
            placeholder="商品標題"
            value={generationForm.product_title || "--"}
            disabled={true}
          />
        </Box>

        <Box mt={2}>
          <ProductTitle variant='h5'>消費者問答次數</ProductTitle>
          <TextFieldWhite
            name="user_question_count"
            placeholder="消費者問答次數"
            value={generationForm.user_question_counts || 0}
            disabled={true}
          />
        </Box>

        <Box mt={2}>
          <ProductTitle variant='h5'>消費者問答摘要</ProductTitle>
          <TextFieldWhite
            name="user_question_summary"
            placeholder="消費者問答摘要"
            value={generationForm.user_question_summary || "--"}
            disabled={true}
            multiline
            maxRows={4}
          />
        </Box>

        <Box mt={2}>
          <ProductTitle variant='h5'>標籤</ProductTitle>
          {generationForm?.user_question_labels?.length > 0 &&
            generationForm.user_question_labels.map((label, index) => {
              return (
                <Chip
                  key={`${label}_${index}`}
                  variant='rounded-rect'
                  color='primary'
                  size="small"
                  label={label}
                  sx={{ margin: '4px' }}
                />
              )
            })}
        </Box>
      </Collapse>
    </Box>
  )
}

export default ProductInfo;